<template>
    <div class="seller-o2o-index">
        <div class="common-header-wrap">
            <mt-header title="配送设置" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
		<div class="main-content">
			<flex-line :show-border="true">
			    <span>开启接单</span>
			    <div slot="right"><mt-radio align="left" class="page-part" v-model="settings.store_o2o_receipt" :options="store_o2o_receipt_options" /></div>
			</flex-line>
			<flex-line :show-border="true">
			    <span>配送方式</span>
			    <div slot="right"><mt-radio align="left" class="page-part" v-model="settings.store_o2o_distribute_type" :options="store_o2o_distribute_type_options" /></div>
			</flex-line>
			<flex-line :show-border="true">
			    <span>自动接单</span>
			    <div slot="right"><mt-radio align="left" class="page-part" v-model="settings.store_o2o_auto_receipt" :options="store_o2o_auto_receipt_options" /></div>
			</flex-line>
			<flex-line :show-border="true">
			    <span>自动派单</span>
			    <div slot="right"><mt-radio align="left" class="page-part" v-model="settings.store_o2o_auto_deliver" :options="store_o2o_auto_deliver_options" /></div>
			</flex-line>
			<flex-line :show-border="true" class="range range-start">
			    <span>开始时间</span>
				<div slot="right" class="timeright">
					<mt-range
							v-model="timeStart"
							:min="0"
							:max="2880"
							:step="30"
							:bar-height="5">
						<div class="range-right" slot="end">{{formatTime(timeStart)}}</div>
					</mt-range>
				</div>
			</flex-line>
			<flex-line :show-border="true" class="range range-start">
			    <span>结束时间</span>
				<div slot="right" class="timeright">
					<mt-range
							v-model="timeEnd"
							:min="0"
							:max="2880"
							:step="30"
							:bar-height="5">
						<div class="range-right" slot="end">{{formatTime(timeEnd)}}</div>
					</mt-range>
				</div>
			</flex-line>
			<flex-line class="field-line" :show-border="true"><span class="field-name">投诉罚款</span><div class="field-line-right" slot="right"><input class="field-input" v-model="settings.store_o2o_complaint_fine" /></div></flex-line>
			<flex-line class="field-line" :show-border="true"><span class="field-name">接单门槛</span><div class="field-line-right" slot="right"><input class="field-input" v-model="settings.store_o2o_min_cost" /></div></flex-line>
			<flex-line class="field-line" :show-border="true"><span class="field-name">自动接单上限</span><div class="field-line-right" slot="right"><input class="field-input" v-model="settings.store_o2o_receipt_limit" /></div></flex-line>
			<flex-line class="field-line" :show-border="true"><span class="field-name">拒接时限</span><div class="field-line-right" slot="right"><input class="field-input" v-model="settings.store_o2o_reject_time" /></div></flex-line>
			<div class="pt-10 pb-10"><div class="common-btn ds-button-large" v-on:click="submit">保存</div></div>
		</div>
    </div>
</template>

<script>
import { getO2oInfo, editO2oInfo } from '../../../api/sellerO2o'
import { Toast } from 'mint-ui'
import flexLine from '../../flexLine'
export default {
  name: 'Index',
  data () {
    return {
      timeStart: 0,
      o2oOpen: 0,
      timeEnd: 2880,
      settings: [],
      // 开启接单
      store_o2o_receipt_options: [
        {
          label: '是',
          value: '1'
        },
        {
          label: '否',
          value: '0'
        }
      ],
      // 配送方式
      store_o2o_distribute_type_options: [
        {
          label: '店铺',
          value: '1'
        }
        // {
        //   label: '平台',
        //   value: '0'
        // }
      ],
      // 自动接单
      store_o2o_auto_receipt_options: [
        {
          label: '是',
          value: '1'
        },
        {
          label: '否',
          value: '0'
        }
      ],
      // 自动派单
      store_o2o_auto_deliver_options: [
        {
          label: '是',
          value: '1'
        },
        {
          label: '否',
          value: '0'
        }
      ]
    }
  },
  created: function () {
    getO2oInfo().then(res => {
      this.o2oOpen = res.result.o2o_open
      this.settings = res.result.o2o_info
      this.timeStart = this.settings.store_o2o_open_start
      this.timeEnd = this.settings.store_o2o_open_end
      if (this.o2oOpen && (this.settings.store_o2o_support || this.settings.is_platform_store == '1')) {
        this.store_o2o_distribute_type_options.push(
          {
            label: '平台',
            value: '0'
          }
        )
      }
      this.settings.store_o2o_receipt = '' + this.settings.store_o2o_receipt
      this.settings.store_o2o_distribute_type = '' + this.settings.store_o2o_distribute_type
      this.settings.store_o2o_auto_receipt = '' + this.settings.store_o2o_auto_receipt
      this.settings.store_o2o_auto_deliver = '' + this.settings.store_o2o_auto_deliver
    }).catch(function (error) {
      Toast(error.message)
    })
  },
  computed: {
  },
  components: {
  	flexLine
  },
  watch: {
    timeEnd: function (timeEnd) {
      if (timeEnd < this.timeStart) {
        this.timeEnd = this.timeStart
      }
    },
    timeStart: function (timeStart) {
      if (timeStart > this.timeEnd) {
        this.timeStart = this.timeEnd
      }
    }
  },
  methods: {
    submit () {
        this.settings.store_o2o_open_start = this.timeStart
        this.settings.store_o2o_open_end = this.timeEnd
      editO2oInfo(this.settings.store_o2o_receipt, this.settings.store_o2o_receipt_limit, this.settings.store_o2o_complaint_fine, this.settings.store_o2o_distribute_type, this.settings.store_o2o_distance, this.settings.store_o2o_fee, this.settings.store_o2o_open_start, this.settings.store_o2o_open_end, this.settings.store_o2o_auto_receipt, this.settings.store_o2o_auto_deliver, this.settings.store_o2o_min_cost, this.settings.store_o2o_reject_time).then(res => {
        Toast(res.message)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    formatTime (time) {
      time = parseInt(time)
      let hour = parseInt(time / 60)
      if (hour < 10) {
        hour = '0' + hour
      } else if (hour > 23) {
        hour = hour - 24
        if (hour < 10) {
          hour = '次日0' + hour
        } else {
          hour = '次日' + hour
        }
      }
      let minute = time % 60
      if (minute < 10) {
        minute = '0' + minute
      }
      return hour + ':' + minute
    }
  }
}
</script>

<style scoped lang="scss">
	.main-content{background: #fff;padding:0 $pageSpace}
	.seller-o2o-index .range .timeright{display: flex;flex: 1;}
    .mint-radiolist {
        display: flex;
    .mint-cell {
        flex: 1;
    .mint-radio-input:checked + .mint-radio-core {
        background-color: #ff9900 !important;
        border-color: #ff9900 !important;
    }
    }
    }

</style>
<style >
    .seller-o2o-index .range .mint-cell-value{flex:2;position:relative}
    .seller-o2o-index .range .mt-range {
        width: 100%;
    }
	.seller-o2o-index .range .right{flex: 2;}
    .seller-o2o-index .range .mt-range .range-right{width:2.5rem}
    .seller-o2o-index .range-start .mt-range-runway{border-top-color: #26a2ff;}
    .seller-o2o-index .range-start .mt-range-progress{background-color:#a9acb1}
</style>
